import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { NegotiatedebitCustomer } from 'src/app/models/negotiatedebit/negotiatedebit-customer';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NegotiatedebitService {

  env:string = environment.apiHost + '/api-orders/secure/negotiatedebit';
  constructor(private http: HttpClient) { }

  getCustomers(): Observable<NegotiatedebitCustomer[]> {
    return this.http.get<NegotiatedebitCustomer[]>(`${this.env}/get-customers`);
  }

  createNegotiateOrder(negotiateDto: any): Observable<any> {
    return this.http.post<any>(`${this.env}/create-negotiation`, negotiateDto, { responseType: 'text' as 'json' }).pipe(map((response: any) => response));
  }

}
